import * as React from 'react';

/**
 * TODO: replace this hook by `import {useLockBodyScroll} from 'react-use'` when there is no hybrid page left.
 */
export const useLockBodyScroll = (lock: boolean) => {
  React.useEffect(() => {
    const originalOverflowStyle = 'initial';
    const originalMarginRight = window.getComputedStyle(document.body).marginRight;

    const restoreBodyAttributes = () => {
      document.documentElement.style.overflow = originalOverflowStyle;
      document.documentElement.style.marginRight = originalMarginRight;
    };

    if (lock) {
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.marginRight = '16px'; // Prevents the page from shifting when the scrollbar is hidden

      return restoreBodyAttributes;
    }

    document.documentElement.style.overflow = originalOverflowStyle;
    document.documentElement.style.marginRight = originalMarginRight;

    return restoreBodyAttributes;
  }, [lock]);
};
